import _ from 'lodash'
import { gEnums } from "../../enums/globalEnums"
import { createRefPath_client } from "../../firestoreData/appData/appRefPaths"
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from "./reducerHelpers/dispatchProps"

const rts = {
  // handleGet_eventsInfo: 'handleGet_eventsInfo',
  handleInit_clientInfo: 'handleInit_clientInfo',
  handleSet_clientEvents: 'handleSet_clientEvents',
  handleSet_clientEventsStatus: 'handleSet_clientEventsStatus',
  handleShow_selectedClientEvent: 'handleShow_selectedClientEvent',
  handleUpdate_clientEvent: 'handleUpdate_clientEvent',
  handleUpdate_clientEventsStatus: 'handleUpdate_clientEventsStatus',
  ...grts
}

const _allowUpdate = true

export const clientInfoReducer = (state, action) => {

  const { database_fns, pathViews, clientEventsStatus, clientEvents } = state
  const { type, dispatch } = action

  const clientInfo_handlers = clientInfoHandlers(dispatch)
  const { handleSet_clientEvents, handleStopUpdate } = clientInfo_handlers

  switch (type) {

    case rts.handleInit_clientInfo:
      return { ...state, ...action.clientInfo }

    case rts.handleShow_selectedClientEvent:
      return { ...state, selectedEvent: action.selectedEvent ? action.selectedEvent : null }

    // case rts.handleGet_eventsInfo:
    //   getClientEventSessions(database_fns, pathViews, handleSet_clientEvents)
    //   return { ...state }

    case rts.handleSet_clientEvents:
      return { ...state, clientEvents: action.clientEvents, latest: action.latest, clientEventsStatus: action.clientEventsStatus, updating: false, dataFromCache: action.dataFromCache, clientsFetched: true }

    case rts.handleSet_clientEventsStatus:
      return { ...state, clientEventsStatus: action.clientEventsStatus, latest: action.latest, updating: false, dataFromCache: action.dataFromCache, clientsFetched: true }

    case rts.handleUpdate_clientEvent:
      const { currentEvent } = action
      const _refPath = createRefPath_client(pathViews, ['events', currentEvent._itemKey])
      if (_allowUpdate) {
        database_fns.set_doc(_refPath, currentEvent, true, handleStopUpdate)
      } else {
        console.log('existingEvent', _refPath, currentEvent)
        handleStopUpdate()
      }
      return { ...state }

    case rts.handleUpdate_clientEventsStatus:
      // const _currentAppData = [...action.currentAppData]
      const activeEvents = []
      _.forEach(clientEventsStatus, (itemData) => {
        const existingEvent = clientEvents?.[itemData._itemKey]
        if (existingEvent?.eventStatusType !== itemData?.eventStatusType) {
          const _selectedItem = _.cloneDeep(itemData)
          const _refPath = createRefPath_client(pathViews, ['events', _selectedItem._itemKey])
          delete _selectedItem._itemKey
          delete _selectedItem.startTimeUTC
          delete _selectedItem.key
          delete _selectedItem.id
          delete _selectedItem._dateInfo
          if (_allowUpdate) {
            database_fns.set_doc(_refPath, _selectedItem, true)
            handleStopUpdate()
          } else {
            console.log('existingEvent', _refPath, _selectedItem)
            handleStopUpdate()
          }
        }
      })
      return { ...state }

    case rts.handleStartUpdate:
    case rts.handleStopUpdate:
    case rts.handleCloseConfirmation:
    case rts.updateSuccess:
    case rts.updateSuccessAlt:
    case rts.updateError:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterConfirmation, questionProps: null })

    default:
      return { ...state }
  }
}

export const clientInfoInitialState = (initState) => {
  return { ...initState }
};

export const clientInfoHandlers = (dispatch) => {
  return {
    handleInit_clientInfo: (clientInfo) => { dispatch({ type: rts.handleInit_clientInfo, dispatch, clientInfo }) },
    handleSet_clientEvents: (clientEvents, latest, clientEventsStatus) => { dispatch({ type: rts.handleSet_clientEvents, dispatch, clientEvents, latest, clientEventsStatus }) },
    handleSet_clientEventsStatus: (clientEventsStatus, latest, dataFromCache) => { dispatch({ type: rts.handleSet_clientEventsStatus, dispatch, clientEventsStatus, latest, dataFromCache }) },
    handleShow_selectedClientEvent: (selectedEvent) => { dispatch({ type: rts.handleShow_selectedClientEvent, dispatch, selectedEvent }) },
    handleUpdate_clientEvent: (currentEvent) => { dispatch({ type: rts.handleUpdate_clientEvent, dispatch, currentEvent }) },
    handleUpdate_clientEventsStatus: (currentAppData) => { dispatch({ type: rts.handleUpdate_clientEventsStatus, dispatch, currentAppData }) },
    ...responseHandlers(dispatch)
  }
}

// const getClientEventSessions = async (database_fns, pathViews, callback) => {

//   const today = new Date();
//   today.setHours(0, 0, 0, 0);

//   const lastMonth = new Date();
//   lastMonth.setMonth(lastMonth.getMonth() - 1);

//   const _refPath = createRefPath_client(pathViews, ['events'])
//   const events = await database_fns.get_data({ refPath: _refPath })

//   const fetchEvents = async () => {
//     // Calculate earliest and latest start dates for each event
//     const updatedEvents = Object.keys(events).map(async (eventKey) => {

//       const event = events[eventKey]
//       const _refPath = createRefPath_client(pathViews, ['events', event._itemKey, 'sessions'])
//       const sessions = await database_fns.get_data({ refPath: _refPath })

//       if (Object.keys(sessions).length > 0) {

//         const startDates = Object.keys(sessions).map((sessionKey) => new Date(sessions[sessionKey].startDate));
//         const earliestStartDate = new Date(Math.min(...startDates));
//         const latestStartDate = new Date(Math.max(...startDates));

//         // Check if today's date is between earliestStartDate and latestStartDate
//         const statuses = {
//           isOngoing: today >= earliestStartDate && today <= latestStartDate,
//           isCompleted: latestStartDate < new Date(),
//           isRecent: latestStartDate >= lastMonth
//         }

//         return {
//           ...event,
//           startDate: formatDate(earliestStartDate),
//           endDate: formatDate(latestStartDate),
//           eventStatusType: statuses.isOngoing ? gEnums.eventStatusTypes.ongoing : statuses.isRecent ? gEnums.eventStatusTypes.recent : statuses.isCompleted ? gEnums.eventStatusTypes.completed : event.eventStatusType,
//         };
//       } else {
//         return {
//           ...event,
//           eventStatusType: gEnums.eventStatusTypes.pending
//         };
//       }
//     });

//     // Update state with events including earliest and latest start dates
//     Promise.all(updatedEvents).then((updatedEventsData) => {
//       const latest = getSessionsData(updatedEventsData)
//       callback(updatedEventsData, latest);
//     })
//   };

//   fetchEvents();

// }

// const getSessionsData = (clientEvents, callback) => {

//   // Find the next and last events based on earliestStartDate using lodash
//   const sortedEvents = _.sortBy(clientEvents, (event) => new Date(event.earliestStartDate));

//   const today = new Date();
//   today.setHours(0, 0, 0, 0);

//   const nextEvent = _.find(sortedEvents, (event) => new Date(event.earliestStartDate) >= today);
//   const lastEvent = _.last(sortedEvents);

//   console.log('Next Event:', nextEvent);
//   console.log('Last Event:', lastEvent);

//   return { nextEvent, lastEvent }

// }

// const formatDate = (date) => {
//   const pad = (num) => (num < 10 ? `0${num}` : num);
//   const month = pad(date.getMonth() + 1); // Months are zero-based
//   const day = pad(date.getDate());
//   const year = date.getFullYear();
//   return `${month}/${day}/${year}`;
// };